// Throws on render so the deployed app can be smoke-tested against
// Sentry by visiting /_sentry-test exactly once. The error is caught
// by the top-level Sentry.ErrorBoundary, captured by Sentry, and the
// fallback UI takes over -- it does not crash the whole app.
export default function SentryTest(): JSX.Element {
  throw new Error('Sentry admin smoke test')
}
